var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title && _vm.value)?_c('div',{staticClass:"voucher-detail-card",attrs:{"title":_vm.title}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('b',{staticClass:"d-block text-center"},[_vm._v(_vm._s(_vm.value))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }